import { render, staticRenderFns } from "./NavigationFolder.vue?vue&type=template&id=6b7e2bcc&"
import script from "./NavigationFolder.vue?vue&type=script&lang=js&"
export * from "./NavigationFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports